<template>
<article>
  <section id="doc" class="section" v-if="page">
  <header>
    <h1 id="title" v-html="page.title.rendered"/>
    <div id="meta" class="subtitle">
      {{friendlyDate | formatDate}}
      <span id="author">&nbsp; <em>by {{author}}</em></span>
      <span id="tags">
        <span v-for="tag in categories">
          &nbsp;<router-link :to="root+'?cat='+tag">
            <b-tag class="is-primary is-small" :class="tag">{{tag}}</b-tag>
          </router-link>
        </span>
      </span>
    </div>
  </header>
  <div id="body" class="content" v-html="page.content.rendered"/>
  <footer>
    <div id="related" class="box">
      <h2>Related Articles:</h2>
      <div class="item" v-for="rel in page['jetpack-related-posts']">
          <img v-if="rel.img && rel.img.src" :src="rel.img.src"
               class="thumb"/>
          <router-link :to="'/slug/'+extractSlug(rel.url)">{{rel.title}}</router-link>
      </div>
    </div>
  </footer>
  <index-launcher class="launcher"></index-launcher>
  </section>
  <section id="doc" v-else>
    <div id="body" class="content">
      Sorry - this is not the page your are looking for...
    </div>
    <index-launcher class="launcher"></index-launcher>
  </section>
</article>

</template>

<script>
import IndexLauncher from '@/components/IndexLauncher'

export default {
  name: 'SlugViewerPage',
  components: {
    IndexLauncher,
  },
  metaInfo() { return {
    title: this.title,
    meta: {} //this.ogMeta,
  }},
  data() { return {
    page: undefined,    
    meta: {},
    curpath: '',
  }},
  computed: {
    root: function() {
      return '/slug'
    },
    friendlyDate: function() {
      return Date.parse(this.page.date)/1000
    },
    author: function() {
      return this.page.author || 'tim'
    },
    categories: function() {
      return this.page.categories.map( c => {
        var cats =this.page._embedded['wp:term'][0].filter(t => t.id==c)
        return cats ? cats[0].name : 'Cat'+c
      })
    },
  },
  methods: {
    maybeReload: function(path) {
      if (path != this.curpath) {
        this.curpath = path
        this.reload(path)
      } else {
        console.log('drop duplicate reload', path)
      }
    },
    reload: function(path) {
      path = path.replace(/\/$/, '') //remove trailing / (prerendered case)
      console.log('RELOAD:', path)
      this.meta = {}
      var posturi = 'https://public-api.wordpress.com/wp/v2/sites/pixxijournal.wordpress.com/posts?slug='+path+'&_fields=content,title,date,categories,jetpack-related-posts,_embedded,_links&_embed=author,wp:term'
      this.$http.get(posturi).then( (rsp) => {
        console.log('## GOT', rsp.body)
        this.page = rsp.body[0]
      }).catch( (err) => {
        console.error('## ERROR\n' + err)
      })
    },
    extractSlug: function(url) {
      var path = url.replace(/\/(\?.*)?$/,'').split('/')
      return path ? path[path.length-1] : ''
    },
    postProcess: function() {
      //send relative links via router
      var links = document.querySelectorAll('#doc a')
      if (links) {
        var absRE = new RegExp('http://|https://|mailto:|//', 'i');
        for (var i=0; i<links.length; ++i) {
          var href = links[i].getAttribute('href')
          console.log('check href=',href)
          var router = this.$router
          if (href && !absRE.test(href)) {
            links[i].onclick = function(ev) {
              ev.preventDefault()
              router.push(ev.currentTarget.getAttribute('href'))
            }
          } else {
            links[i].setAttribute('target', links[i].getAttribute('target') || '_blank')
          }
        }
      }
    },
  },
  watch: {
    content: function() {
      this.$nextTick(function() {
        if (this.$route.hash) {
          var anchors = document.getElementsByName(this.$route.hash.slice(1))
          if (anchors) {
            anchors[0].scrollIntoView();
          }
        }
        this.postProcess();
      })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => vm.maybeReload(to.params.docid))
  },
  beforeRouteUpdate(to, from, next) {
    // re-using component for another doc page
    this.maybeReload(to.params.docid)
    next()
  },
  mounted() {
    //for pre-rendered page
    this.maybeReload(this.$route.params.docid)
  }

}
</script>

<style scoped>
section {
    margin-top: 2em;
    margin-bottom: 2em;
}
.fill-height {
    min-height: 50vh;
}
#summary {
    color: #363636;
    margin: 1ex 2em 1em 2em;
}
.tag.draft {
    color: black;
    background-color: yellow;
}

figure.thumb {
  padding: 1ex;
  background-color: white;
  border: thin silver solid;
  max-width: 10em;
  border: thin solid silver;
  float: left;
  margin: 1ex 2ex 1ex 0;
}

#doc {
  max-width: 120ex;
  margin: auto;
}
#doc header {
  -background-color: #363636;
  margin: 2em 0 2em 0;
  padding: 1ex;
  border-bottom: .5ex solid black;
}

#doc header h1 {
  font-size: 2.5em;
  font-weight: bold;
  color: black;
}
#doc header #meta {
  display: flex;
  justify-content: space-between;
}
#doc header #meta #tags {
  margin-left: auto;
}
#doc #float-clearer { clear: both; }

#doc footer #related {
    padding-left: 3em;
}
#doc footer #related h2 {
    font-size: 120%;
}
#doc footer #related .item{
    padding-left: 2em;
    padding-bottom: .5ex;
}
#doc footer #related .thumb {
    width: 5em;
    height: 4em;
    vertical-align: middle;
    margin-right: 1ex;
}
.launcher { margin: 2em 0; }
</style>

<style>
/* markdown body tags are not scoped */
#body figure {
  padding: 1ex;
  margin: auto;
  width: 40rem;
  max-width: 90vw;;
  x-display: block;
}
#body figure:not(.nobox) {
  background-color: white;
  border: thin silver solid;
}
#body figure figcaption {
    padding: 1ex 10%;
    font-size: 1rem;
}
#body figure.medium {
  max-width: 40em;
}
#body figure.size-medium {
    max-width: 20em;
    x-border: none;
}
#body figure.logo {
    max-width: 3em;
    border: none;
}
#body figure.left {
  float: left;
  margin: 1ex 1em 1ex 0;
}
#body figure.right {
  float: right;
  margin: 1ex 0 1ex 1em;
}
#body .clear {
  clear: both;
}
#body h1 { font-size: 1.75em; font-weight: bold; clear: both;
           border-bottom: solid #ff3860; margin-right: 5em; }
#body h2 { font-size: 1.5em; font-weight: bold; clear: both;}
#body h3 { font-size: 1.25em; font-weight: bold; clear: both;}
#body table { width: initial; max-width: 100%; min-width: 50%; }
#body p { font-size: 125%; }
</style>



// WEBPACK FOOTER //
// src/components/SlugViewerPage.vue